var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTournamentsAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8494_56418)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E2E6F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8494_56418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5245 55.8988C49.1199 55.8988 56.8985 48.1201 56.8985 38.5247C56.8985 28.9293 49.1199 21.1506 39.5245 21.1506C29.929 21.1506 22.1504 28.9293 22.1504 38.5247C22.1504 48.1201 29.929 55.8988 39.5245 55.8988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5246 58.0209C28.7436 58.0209 20 49.2773 20 38.5246C20 27.7719 28.7436 19 39.5246 19C50.3056 19 59.0493 27.7436 59.0493 38.5246C59.0493 49.3056 50.3056 58.0492 39.5246 58.0492V58.0209ZM39.5246 21.8297C30.3282 21.8297 22.8297 29.2999 22.8297 38.5246C22.8297 47.7493 30.3282 55.2196 39.5246 55.2196C48.721 55.2196 56.2196 47.721 56.2196 38.5246C56.2196 29.3282 48.721 21.8297 39.5246 21.8297Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0958 63.8499L50.4473 51.0882L52.4563 49.1074L65.1049 61.8692L63.0958 63.8499Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5246 52.1919C47.0729 52.1919 53.1919 46.0728 53.1919 38.5246C53.1919 30.9764 47.0729 24.8574 39.5246 24.8574C31.9764 24.8574 25.8574 30.9764 25.8574 38.5246C25.8574 46.0728 31.9764 52.1919 39.5246 52.1919Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0033 32.9503C51.5506 31.9033 51.1545 31.3091 50.7583 30.7148L48.2116 32.0165L48.0135 32.356L48.2116 35.0442L46.6836 37.4777L47.1646 37.9588L50.1358 36.0629L50.3056 35.7516L50.1641 33.5445L52.0033 32.922V32.9503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1852 37.9587L37.5151 33.9972V33.7143L34.1761 27.8852L34.6571 25.7629C32.7047 26.4704 31.205 27.5456 30.1863 28.536L29.9033 29.8659L30.0165 30.2055L34.0912 33.7709L33.0442 38.7511L33.1574 39.0906L36.2983 42.0334L37.4868 47.0136H38.1942L38.9865 40.8167L38.8733 40.5054L36.2417 37.987L36.1852 37.9587Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8494_56418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8494_56418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.1047,
    height: 44.85,
    fill: "white",
    transform: "translate(20 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTournamentsAvailable);
export default __webpack_public_path__ + "static/media/no-tournaments-available.b001f3752b81723ab789e06c96a87511.svg";
export { ForwardRef as ReactComponent };